(function () {
  'use strict';

  var SIZE_CHART_IMAGE =
    'https://cdn.shopify.com/s/files/1/0690/0131/4442/files/33e2852f4a01cae5aa25057861201d13.png?v=1741273092';
  var TRUST_IMAGES = [
    '/cdn/shop/files/Trust_1_100x100.png?v=1741706500',
    '/cdn/shop/files/Trust_2_100x100.png?v=1741706500',
    '/cdn/shop/files/Trust_3_100x100.png?v=1741707106',
    '/cdn/shop/files/Trust_4_100x100.png?v=1741707106'
  ];

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function getSizeChartModal() {
    var existing = document.getElementById('WellaSizeChartModal');
    if (existing) return existing;

    var modal = document.createElement('div');
    modal.id = 'WellaSizeChartModal';
    modal.className = 'wella-size-chart-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'WellaSizeChartTitle');
    modal.innerHTML =
      '<button class="wella-size-chart-modal__overlay" type="button" aria-label="إغلاق جدول المقاسات"></button>' +
      '<div class="wella-size-chart-modal__dialog" tabindex="-1">' +
        '<button class="wella-size-chart-modal__close" type="button" aria-label="إغلاق جدول المقاسات">&times;</button>' +
        '<h2 id="WellaSizeChartTitle">مخطط الحجم</h2>' +
        '<div class="wella-size-chart-modal__content">' +
          '<img src="' + SIZE_CHART_IMAGE + '" alt="جدول المقاسات الحريمي من WELLA EGYPT" width="1200" height="900">' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);
    modal.querySelector('.wella-size-chart-modal__overlay').addEventListener('click', closeSizeChart);
    modal.querySelector('.wella-size-chart-modal__close').addEventListener('click', closeSizeChart);
    return modal;
  }

  function openSizeChart(event) {
    if (event) event.preventDefault();
    var modal = getSizeChartModal();
    modal.hidden = false;
    document.documentElement.classList.add('wella-modal-open');
    modal.querySelector('.wella-size-chart-modal__dialog').focus();
  }

  function closeSizeChart() {
    var modal = document.getElementById('WellaSizeChartModal');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('wella-modal-open');
    var trigger = document.querySelector('.wella-product-facts__size-chart');
    if (trigger) trigger.focus();
  }

  function addAfterBuyTools() {
    if (!isProductPage() || document.querySelector('.wella-product-afterbuy')) return;

    var legacyHost = document.querySelector(
      '.product-details .buy-buttons-block[data-wella-legacy-trust-badges="true"]'
    );
    if (!legacyHost) return;

    var paymentButton = legacyHost.querySelector('.shopify-payment-button');
    if (!paymentButton) return;
    var deliveryTime = legacyHost.querySelector('.wella-product-delivery');
    var insertionAnchor = deliveryTime || paymentButton.closest('.product-form__buttons') || paymentButton;

    var tools = document.createElement('div');
    tools.className = 'wella-product-afterbuy';
    tools.innerHTML =
      '<div class="wella-product-afterbuy__trust" aria-label="مزايا الطلب من WELLA EGYPT">' +
        TRUST_IMAGES.map(function (src) {
          return '<img src="' + src + '" alt="ميزة شراء من WELLA EGYPT" width="100" height="100" loading="lazy">';
        }).join('') +
      '</div>';

    insertionAnchor.insertAdjacentElement('afterend', tools);
  }

  function bindSizeChart() {
    if (!isProductPage()) return;
    document.querySelectorAll('.wella-product-facts__size-chart').forEach(function (link) {
      link.dataset.wellaModalBound = 'true';
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
    });
  }

  function parseValueList(value) {
    return String(value || '')
      .split(',')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function randomValue(values) {
    return values[Math.floor(Math.random() * values.length)];
  }

  function formatFact(template, values) {
    return String(template || '')
      .replace(/\[number\]/g, values.number || '')
      .replace(/\[hours\]/g, values.hours || '');
  }

  function bindDynamicProductFacts() {
    document.querySelectorAll('[data-wella-viewing]').forEach(function (element) {
      if (element.dataset.wellaDynamicBound === 'true') return;

      var values = parseValueList(element.dataset.wellaViewingNumbers);
      var template = element.dataset.wellaViewingTemplate;
      var intervalSeconds = Math.max(1, Number(element.dataset.wellaViewingInterval) || 5);
      if (!values.length || !template) return;

      element.dataset.wellaDynamicBound = 'true';
      var timer = window.setInterval(function () {
        if (!document.documentElement.contains(element)) {
          window.clearInterval(timer);
          return;
        }
        var textTarget = element.querySelector('[data-wella-fact-text]') || element;
        textTarget.textContent = formatFact(template, { number: randomValue(values) });
      }, intervalSeconds * 1000);
    });

    document.querySelectorAll('[data-wella-sold]').forEach(function (element) {
      if (element.dataset.wellaDynamicBound === 'true') return;

      var soldValues = parseValueList(element.dataset.wellaSoldNumbers);
      var hourValues = parseValueList(element.dataset.wellaSoldHours);
      var template = element.dataset.wellaSoldTemplate;
      var delaySeconds = Math.max(1, Number(element.dataset.wellaSoldDelay) || 5);
      if (!soldValues.length || !hourValues.length || !template) return;

      element.dataset.wellaDynamicBound = 'true';
      window.setTimeout(function () {
        if (!document.documentElement.contains(element)) return;
        var textTarget = element.querySelector('[data-wella-fact-text]') || element;
        textTarget.textContent = formatFact(template, {
          number: randomValue(soldValues),
          hours: randomValue(hourValues)
        });
      }, delaySeconds * 1000);
    });
  }

  function init() {
    if (!isProductPage()) return;
    bindSizeChart();
    bindDynamicProductFacts();
    addAfterBuyTools();
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeSizeChart();
  });
  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('.wella-product-facts__size-chart')
      : null;
    if (!trigger || !isProductPage()) return;
    openSizeChart(event);
  });
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function updateIndependentSkuBlocks(html) {
    if (!html) return;
    document.querySelectorAll('[data-wella-sku][data-section-id]').forEach(function (current) {
      var updated = html.getElementById(current.id);
      if (!updated) return;
      current.innerHTML = updated.innerHTML;
      current.classList.toggle('hidden', updated.classList.contains('hidden'));
    });
  }

  document.addEventListener(typeof MainEvents !== 'undefined' && MainEvents.variantUpdate ? MainEvents.variantUpdate : 'variant:update', function (event) {
    updateIndependentSkuBlocks(event.detail && event.detail.data && event.detail.data.html);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      updateIndependentSkuBlocks(event && event.data && event.data.html);
    });
  }
})();

